const ErrorMessage = ({ children }: React.HTMLAttributes<HTMLParagraphElement>) => {
  return <p className="text-rose-500 py-1 px-2 rounded-md bg-red-50">⚠ {children}</p>;
};

export default ErrorMessage;
